import { Link } from 'react-router-dom';
import { movieCategories, siteInfo } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold text-primary-500 tracking-tight">
                555<span className="text-white">影视</span>
              </span>
            </Link>
            <p className="text-sm text-gray-400 leading-relaxed">
              {siteInfo.slogan}。{siteInfo.description.substring(0, 50)}...
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">电影分类</h4>
            <ul className="space-y-2.5">
              {movieCategories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-gray-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {movieCategories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-gray-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-primary-400 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-primary-400 transition-colors">
                  联系方式
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-primary-400 transition-colors">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-primary-400 transition-colors">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | {siteInfo.fullName}
          </p>
          <p className="text-xs text-gray-500">
            本站所有资源信息均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}